module.exports = __webpack_public_path__ + "assets/3bff5dd47ad27a4ecf79ceef0ca9d7e2.png";